import type {Query, QueryFilters} from '@tanstack/react-query'

import {isQueryForItems, paginatedMemexItemsQueryKey} from './query-keys'

// This is the query filter that we use to get the active queries for the memex items query - it can be passed
// to `setQueryData` to update the active queries for the memex items query.
// We include a `predicate` to filter out queries indirectly related to items/groups data, such as
// page params, slice by data, total counts, etc.
export const activeMemexItemsQueryFilter: QueryFilters = {
  queryKey: ['memex', paginatedMemexItemsQueryKey],
  exact: false,
  type: 'active',
  predicate: (query: Query) => {
    return isQueryForItems(query)
  },
}
